import {
  MenuList,
  MenuItem,
  MenuGroupHeader,
} from '@fluentui/react-components';
import {
  ArrowSortDownFilled,
  ArrowSortUpFilled,
  ChevronDownFilled,
} from '@fluentui/react-icons';
import styled, { css } from 'styled-components';

export const TableHeader = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0 2.5px 0 -1px ${(props) => props.theme.selectedDateBackground};
  background: ${(props) => props.theme.mainBackgorund};
`;

export const TableHeadRow = styled.tr``;

export const TableHeaderCell = styled.th`
  position: relative;

  padding: 16px 12px;
  text-align: left;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  color: ${(props) => props.theme.textMainColor};
`;

export const TableHeaderCellContent = styled.div`
  display: grid;
  grid-template-columns: max-content 16px 16px;
  grid-template-rows: auto;
  grid-template-areas: 'text icon dropdown';
  gap: 7px;
  align-items: center;
  font-weight: 400;
`;

export const DisplayName = styled.span`
  grid-area: text;
  font-weight: 600;
  color: ${(props) => props.theme.serviceDeskTableHeaderCellColor};
  &.activeSorting {
    color: ${(props) =>
      props.theme.serviceDeskTableHeaderCellColorSortingActive};
  }
`;

export const Icon = css`
  grid-area: icon;
  width: 16px;
  height: 16px;
  font-size: 16px;
`;
export const SortDownIcon = styled(ArrowSortDownFilled)`
  ${Icon}
`;

export const SortUpIcon = styled(ArrowSortUpFilled)`
  ${Icon}
`;

export const EmptySortIcon = styled.div`
  ${Icon}
`;

export const TableHeaderDropdownIcon = styled(ChevronDownFilled)`
  ${Icon}
  grid-area: dropdown;
  cursor: pointer;
`;

export const ColumnDropdownBackdropContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
`;

export const ColumnDropDownWrapper = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  &.last {
    left: auto;
    right: 0;
  }
  width: max-content;
  background: ${(props) => props.theme.mainBackgorund};
  z-index: 100;
  border-radius: 4px;
  box-shadow:
    0px 8px 16px 0px rgba(0, 0, 0, 0.14),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
`;

export const ColumnDropDownList = styled(MenuList)``;

export const ColumnDropDownItem = styled(MenuItem)`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  padding: 0 15px;
`;

export const ColumnDropDownGroupHeader = styled(MenuGroupHeader)`
  padding: 10px 15px;
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.primaryButtonBackground};
`;

export const FiltersWrapper = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  width: max-content;
  max-height: 200px;
  ::-webkit-scrollbar {
    display: none;
  }
`;
